"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProgress = void 0;
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var classnames_1 = __importDefault(require("classnames"));
var apps_shared_1 = require("@l2p/apps-shared");
var FixedButton_1 = require("@l2p/ui-components/src/Buttons/FixedButton");
var link_1 = __importDefault(require("next/link"));
var useProgress = function (_a) {
    var startWageringBalance = _a.startWageringBalance, wageringBalance = _a.wageringBalance, canWithdraw = _a.canWithdraw;
    var hasProgress = !!startWageringBalance && !!wageringBalance;
    if (!canWithdraw) {
        return {
            current: 0,
            required: 0,
            currency: '',
            hasProgress: false,
            hideWithdrawalUnavailableCard: false,
        };
    }
    if (!hasProgress || !(wageringBalance === null || wageringBalance === void 0 ? void 0 : wageringBalance.amount)) {
        return {
            current: 0,
            required: 0,
            currency: '',
            hasProgress: false,
            hideWithdrawalUnavailableCard: true,
        };
    }
    var start = Number(startWageringBalance.amount) || 0;
    var wagering = Number(wageringBalance.amount) || 0;
    var current = start - wagering;
    var currency = startWageringBalance.currency;
    var derivedProgress = current / start;
    var computedProgress = typeof derivedProgress === 'number' && Number.isFinite(derivedProgress)
        ? Math.max(0, Math.min(1, derivedProgress))
        : undefined;
    return {
        currency: currency,
        currentAmount: current,
        requiredAmount: start,
        hasProgress: true,
        computedProgress: computedProgress,
        hideWithdrawalUnavailableCard: (!!computedProgress && computedProgress > 1) ||
            (current || 0) >= (start || 0),
    };
};
exports.useProgress = useProgress;
var WithdrawalUnavailableCard = function (_a) {
    var hasProgress = _a.hasProgress, computedProgress = _a.computedProgress, currentAmount = _a.currentAmount, currency = _a.currency, requiredAmount = _a.requiredAmount, hideWithdrawalUnavailableCard = _a.hideWithdrawalUnavailableCard, className = _a.className;
    var locale = (0, next_intl_1.useLocale)();
    var t = (0, next_intl_1.useTranslations)('withdrawalsUnavailableCard');
    if (hideWithdrawalUnavailableCard) {
        return null;
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.card, className) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, hasProgress ? t('progress.title') : t('activeBonus.title')),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.description }, hasProgress
                ? t('progress.description')
                : t('activeBonus.description'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.actions },
            hasProgress && (react_1.default.createElement("div", { className: styles_module_scss_1.default.progressContainer },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.amounts },
                    typeof currentAmount !== 'undefined' && (react_1.default.createElement("span", { className: styles_module_scss_1.default.current },
                        (0, apps_shared_1.getCurrencySymbol)(currency),
                        currentAmount)),
                    typeof currentAmount !== 'undefined' ? (react_1.default.createElement("span", { className: styles_module_scss_1.default.required }, "/")) : (''),
                    typeof requiredAmount !== 'undefined' && (react_1.default.createElement("span", { className: styles_module_scss_1.default.required },
                        (0, apps_shared_1.getCurrencySymbol)(currency),
                        requiredAmount))),
                hasProgress && (react_1.default.createElement("div", { className: styles_module_scss_1.default.progress },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.progressFill, style: { width: "".concat(Math.round(computedProgress * 100), "%") } }))))),
            react_1.default.createElement(link_1.default, { href: "/".concat(locale).concat(hasProgress ? '' : '/account/bonuses/cash') },
                react_1.default.createElement(FixedButton_1.FixedButton, { className: styles_module_scss_1.default.action, width: "unset" }, hasProgress
                    ? t('progress.buttonText')
                    : t('activeBonus.buttonText'))))));
};
exports.default = WithdrawalUnavailableCard;
